module.exports = __webpack_public_path__ + "media/img/list-style-image-532b5e1ff268e39a8a86adfae76bfd14.svg";